import {CartItem} from './cart-item.model';
export class ShoppingCart {
  items: Array<CartItem> = []
}



// WEBPACK FOOTER //
// ./src/main/webapp/stay-mgmt/app/common/model/shopping-cart/shopping-cart.model.ts